// extracted by mini-css-extract-plugin
module.exports = {"main":"footer_main__kExfD","container":"footer_container__1zh2h","footer_logo":"footer_footer_logo__2vj-d"};